import $ from 'jquery'
import store_dhis2 from "@/store/mods/consultations/dhis-diagnostics"

export default {
    name: 'manage-send-stat',
    components: {},
    props: {
        statistique_dhis2: Object,
        curr_month: Object,
        toggler: Number
    },
    data() {
        return {
            send_loading: false,
            is_confirm: false,
            is_error: false,
            stat_data: {
                period: "",
                dataValues: []
            },
            period_invald: false
        }
    },

    watch: {
        toggler() {
            this.is_confirm = false
            this.period_invald = false
            this.is_error = false
            this.setStatData()
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        setStatData() {
            let m = this.curr_month.id 
            m = (m < 10)?'0'+m:m
            this.stat_data.period = this.current_date.getFullYear()+m

            this.stat_data.dataValues = []
            
            const patient_consultes = this.statistique_dhis2.patient_consultes.stat
            const anciens_cas = this.statistique_dhis2.cas_diagnostics.stat_anciens_cas
            const nouveaux_cas = this.statistique_dhis2.cas_diagnostics.stat_nouveaux_cas

            const cas_suspects  = this.statistique_dhis2.cas_paludisme.stat_cas_suspects
            const tdr_effectues = this.statistique_dhis2.cas_paludisme.stat_cas_tdr
            const tdr_pos = this.statistique_dhis2.cas_paludisme.stat_cas_tdr_pos
            const palu_confirme = this.statistique_dhis2.cas_paludisme.stat_cas_palu_confirme
            const palu_simple_confirme = this.statistique_dhis2.cas_paludisme.stat_cas_palu_simple_confime

            const autres_maladies = this.statistique_dhis2.maladies_parasitaires.stat
            let maladies = []
            autres_maladies.forEach(m => {
                m.cat.forEach(el => {
                    maladies.push(el)
                });
            });

            this.stat_data.dataValues = [
                ...patient_consultes,
                ...anciens_cas,
                ...nouveaux_cas,
                ...maladies,
                ...cas_suspects,
                ...tdr_effectues,
                ...tdr_pos,
                ...palu_confirme,
                ...palu_simple_confirme
            ]  
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        sendStatDiagnostics(selector) {
            let confirm = document.getElementById(selector);
            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé 
                $('.err-msg').fadeIn(500)
                return
            }
            
            this.send_loading = true
            store_dhis2.sendStatConsultationDHIS2(this.stat_data).then((response) => {
                if (response.success) {
                    this.successToast('Envoie effectuée avec succès')
                    this.$refs.stat_dhis.click()
                } else {
                    if (response.code === 500) {
                        this.is_error = true
                    } else if (response.code === 409) {
                        this.period_invald = true
                    }
                }
                this.send_loading = false
            }).catch(() => {
                this.send_loading = false
                this.is_error = true
            })
        }
    }
}